import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

export interface DashboardSidePanelProps {
  spk: Token
  claimedAmount: NormalizedNumber
  openStakeDialog: () => void
}

export function DashboardSidePanel({ spk, claimedAmount, openStakeDialog }: DashboardSidePanelProps) {
  return (
    <MainPanel>
      <SubPanel>
        <SubpanelTitle text="Claimed amount" explainer="Airdrop amount you have already claimed." />
        <SubPanelSpkAmount spk={spk} amount={claimedAmount} />
        <SubpanelSpkAmountUsd spk={spk} amount={claimedAmount} />
      </SubPanel>
      <Button variant="tertiary" className="mt-4 w-full" onClick={openStakeDialog}>
        Stake SPK
      </Button>
    </MainPanel>
  )
}

function MainPanel({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <Panel variant="secondary" spacing="none" className={cn('rounded-md p-6', className)}>
      {children}
    </Panel>
  )
}

function SubPanel({ children }: { children: React.ReactNode }) {
  return (
    <Panel
      variant="quaternary"
      spacing="none"
      className="-mt-4 -mx-4 flex min-h-[164px] flex-col items-center justify-center gap-3 py-12 md:min-h-[174px]"
    >
      {children}
    </Panel>
  )
}

function SubpanelTitle({ text, explainer }: { text: string; explainer?: string }) {
  return (
    <div className="flex items-center gap-1">
      <div className="typography-label-2 text-tertiary">{text}</div>
      {explainer && <Info className="text-secondary">{explainer}</Info>}
    </div>
  )
}
function SubPanelSpkAmount({ spk, amount }: { spk: Token; amount: NormalizedNumber }) {
  return (
    <div className="flex items-center gap-2">
      <img src={spk.logo} alt={spk.symbol} className="size-10" />
      <div
        className="typography-heading-2 text-primary-inverse"
        data-testid={testIds.spkAirdrop.dashboard.sidePanel.spkAmount}
      >
        {spk.format(amount, { style: 'compact' })}
      </div>
    </div>
  )
}

function SubpanelSpkAmountUsd({ spk, amount }: { spk: Token; amount: NormalizedNumber }) {
  return (
    <div className="typography-label-2 text-tertiary" data-testid={testIds.spkAirdrop.dashboard.sidePanel.spkAmountUsd}>
      {spk.formatUSD(amount, { compact: true })}
    </div>
  )
}
